import Swal, { SweetAlertIcon } from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import Expadir from "../Components/Utils/Expandir";

const ReactSwal = withReactContent(Swal);
export function AlertError(title: string, describe: string, obs?: string) {
    return ReactSwal.fire({
        icon: "error",
        title: <span>{title}</span>,
        showConfirmButton: false,
        html: (
            <>
                <div>{describe}</div>
                {obs && obs !== describe && (
                    <Expadir unmountOnExit>{obs}</Expadir>
                )}
            </>
        ),
        showCloseButton: true,
    });
}

export function AlertSuccess(Title: string) {
    return Swal.fire({
        icon: "success",
        title: Title,
        showConfirmButton: false,
        timer: 2000,
    });
}

export function AlertWarning(TitleDescription: string, title?: string) {
    return Swal.fire({
        icon: "warning",
        title: title ?? TitleDescription,
        text: title ? TitleDescription : undefined,
        showConfirmButton: false,
        showCloseButton: true,
    });
}

export function AlertInfo(Title: string) {
    return Swal.fire({
        icon: "info",
        html: Title,
        showConfirmButton: true,
        confirmButtonText: "<i class='la la-check'></i> Ok!",
        // timer: 10000,
    });
}

export function AlertQuestion(Title: string) {
    return Swal.fire({
        icon: "question",
        title: Title,
        showConfirmButton: false,
        timer: 2000,
    });
}

export function AlertConfirm(title: string, icon: SweetAlertIcon = "info") {
    return AlertConfirmation(title, undefined, icon);
}

export function AlertConfirmation(
    title: string,
    text: string | undefined,
    icon: SweetAlertIcon = "info",
    options?: {
        confirmButtonText?: string | false;
        cancelButtonText?: string | false;
    }
) {
    return Swal.fire({
        title,
        html: text,
        icon,
        buttonsStyling: false,
        showConfirmButton: options?.confirmButtonText !== false,
        confirmButtonText:
            options?.confirmButtonText || "<i class='la la-check'></i> Sim!",
        showCancelButton: options?.cancelButtonText !== false,
        cancelButtonText:
            options?.cancelButtonText ||
            "<i class='la la-thumbs-down'></i> Não",
        customClass: {
            confirmButton: "btn btn-outline-success",
            cancelButton: "btn btn-default",
        },
        showClass: {
            popup: "animate__animated animate__wobble",
        },
        hideClass: {
            popup: "animate__animated animate__bounceOut",
        },
    });
}
